import type React from 'react';
import ReviewNotes from 'components/features/review-notes';
import { SubmissionTabProps } from 'routes/Submissions/SubmissionDetail/navigation-tab/submission-config-tabs';
import { EPeerReviewTabsKeys } from 'components/features/peer-review/peer-review-tabs/types';
import { useCallback, useState } from 'react';
import PeerReviewTab from 'components/features/peer-review/peer-review-tabs';

const PeerReview: React.FC<SubmissionTabProps> = ({
  submission,
  navigateNext,
}) => {
  const [activeTab, setActiveTab] = useState<string>(
    EPeerReviewTabsKeys.ReviewNotes
  );

  const handleNavigateNext = useCallback(() => {
    // Skip 1 step to skip Quote Generation tab
    navigateNext(2);
  }, [navigateNext]);

  return (
    <div className="rounded-lg bg-[#E3F2FB]">
      <div className="flex items-center justify-between">
        <div className="pt-2">
          <PeerReviewTab activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
      </div>

      {activeTab === EPeerReviewTabsKeys.ReviewNotes && (
        <div className="pb-2">
          <ReviewNotes
            navigateNext={handleNavigateNext}
            submissionId={submission.submissionId}
            submissionStatus={submission.status}
          />
        </div>
      )}
    </div>
  );
};

export default PeerReview;
